import React from 'react'
import { Link } from 'react-router-dom'

const defaultClass = 'link'

export default ({external, extraClassName, className, children, ...props}) => {
  if (extraClassName && className) throw new Error('extraClassName and className are mutually exclusive')
  className = className === undefined ? defaultClass : className
  if (extraClassName) className += ' ' + extraClassName

  return external
    ? <a href={props.to} className={className} target='_blank'>{children}</a>
    : <Link className={className} {...props}>{children}</Link>
}



// WEBPACK FOOTER //
// ./client/src/components/Link.js